import React from 'react';
import Downshift from 'downshift';
import { BadgeDropdownContainer } from './style';
import Config from 'api/config';

const itemToString = item => (item === null ? '' : String(item));

function getBadgeName(user) {
  return user.full_name
    ? user.full_name
    : user.email
        .split('@')[0]
        .split('.')
        .join(' ');
}

export const getFreshIdUrl = (currentAccount) => {
  return `https://${currentAccount.freshid_organization}`;
};

export const getLogoutUrl = (currentAccount) => {
  const freshIdAPIUrl = getFreshIdUrl(currentAccount);
  const redirectUri = encodeURIComponent(
    `${window.location.origin}/admin/freshid/logout/`
  );
  const logOutUrl = `${freshIdAPIUrl}/api/v2/logout?post_logout_redirect_uri=${redirectUri}`;
  return logOutUrl;
};

const ProfileDropdown = ({ user, currentAccount }) => {
  const USER_MENUS = [
    {
      label: 'Profile',
      href: `${getFreshIdUrl(currentAccount)}/profile?redirect_uri=${window.location.origin}`,
      rel: 'noreferrer',
      target: '_blank'
    },
    {
      label: 'Logout',
      href: getLogoutUrl(currentAccount)
    }
  ];

  if (window.SurveyWidget) {
    if (Config.ENV === "production") {
      let contact = {
        "first_name": user.first_name,
        "last_name": user.last_name,
        "work_email": user.email,
        "designation": "",
        "address": "",
        "city": "",
        "state": "",
        "country": "",
        "zipcode": "",
        "language": "EN",
        "timezone": currentAccount.timezone,
        "industry": "",
        "company_name": currentAccount.name,
        "company_website": "",
        "last_emailed": "",
        "unsubscribe_time": "",
        "email_state": "",
        "product_role": user.role === "OW" ? "Owner" : user.role === "AD" ? "Admin" : "Editor",
        "product_name": "FRESHSTATUS",
        "product_signup_date": new Date(currentAccount.created_on).toISOString(),
        "account_name": currentAccount.name,
        "account_url": currentAccount.freshid_accounts_name + ".freshstatus.io",
        "product_account_id": currentAccount.id.toString(),
        "plan": "FREE"
      }
      
      window.SurveyWidget.init({
        type: "default",
        delay: 2,
        include_unsubscribe :true,
        survey_id: "a2adb445-3696-4be5-ac25-4b4c2415c469",
        survey_collector_id: "SC-110",
        contact: contact
      });
    } else if (
        localStorage.getItem('surveyId') !== '' &&
        localStorage.getItem('collectorId') !== ''
      ) {
      window.SurveyWidget.init({
        type: localStorage.getItem('widgetType') || 'default',
        delay: localStorage.getItem('delay') || 5,
        include_unsubscribe:
          localStorage.getItem('unsubscribe') === 'true' || true,
        survey_id: localStorage.getItem('surveyId'),
        survey_collector_id: localStorage.getItem('collectorId'),
        contact: {
          work_email: user.email
        }
      });
    }
  }

  return (
    <BadgeDropdownContainer>
      <Downshift itemToString={itemToString}>
        {({ getItemProps, isOpen, toggleMenu }) => (
          <div className="btn-group">
            <div className="badge badge-icon" role="none" onClick={toggleMenu}>
              {user ? user.email[0].toUpperCase() : '...'}
            </div>
            {isOpen ? (
              <div
                className={`profile-dropdown droplist-menu ${isOpen &&
                  'dropdown-menu--open'}`}
              >
                <div className="profile-dropdown__item profile-dropdown__textitem">
                  <div className="text__content text--semibold">
                    {getBadgeName(user)}
                  </div>
                  <div className="text__infotext">{user.email}</div>
                </div>
                {USER_MENUS.map(item => (
                  <a
                    {...getItemProps({ item })}
                    key={item.label}
                    className="profile-dropdown__item"
                    style={{ cursor: 'pointer' }}
                    href={item.href}
                    rel={item.rel}
                    target={item.target}
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            ) : null}
          </div>
        )}
      </Downshift>
    </BadgeDropdownContainer>
  );
};
export default ProfileDropdown;
